import materialIcons from "../icons/smartsearch/materials"
import colorIcons from "../icons/smartsearch/colors"

function SmartsearchMaster() {
  let masters = __SMARTSEARCH_MASTER__
  this.priceRangeMasters = masters.price_range_masters.map(pr => ({range: pr.range, text: pr.text}))
  this.priceMasters = masters.price_masters.map(p => ({price: p.price, text: p.text}))
  this.materialMasters = Object.keys(masters.material_masters).map(key => ({
    material: key,
    text: masters.material_masters[key].text,
    longText: masters.material_masters[key].long_text,
    icon: materialIcons[key]
  }))

  this.strapMasters = Object.keys(masters.strap_masters).map(key => ({strap: key, text: masters.strap_masters[key].text}))

  this.colorMasters = Object.keys(masters.color_masters).map(key => ({
    color: key,
    text: masters.color_masters[key].text,
    longText: masters.color_masters[key].long_text,
    icon: key == 'skeleton' ? undefined : colorIcons[key]
  }))
  this.caseWidthMasters = masters.case_width_masters.map(cw => ({caseWidth: cw.case_width, text: cw.text }))
  this.caseWidthRangeMasters = masters.case_width_range_masters.map(cwr => ({caseWidth: cwr.case_width, text: cwr.text}))

  this.genderMasters = Object.keys(masters.gender_masters).map(key => ({gender: key, text: masters.gender_masters[key].text }))
  this.waterproofsMasters = masters.waterproofs_masters.map(w => ({waterproofs: w.waterproofs, text: w.text }))

  this.movementMasters = Object.keys(masters.movement_masters).map(key => ({movement: key, text: masters.movement_masters[key].text}))

  this.functionMasters = Object.keys(masters.function_masters).map(key => ({function: key, text: masters.function_masters[key].text }))
}
export default SmartsearchMaster
